import { projectApi } from '@highlight-cp/project-api';

import { PROJECT_TYPES } from './constants';

const useGetProjectsList = () => {
  const { data, isLoading, error } = projectApi.useGetProjectsQuery({
    publicId: undefined,
    type: PROJECT_TYPES,
  });

  return {
    data,
    isLoading,
    error,
  };
};

export default useGetProjectsList;
